/** @jsxImportSource @emotion/react */
import { Typography } from "antd";
import { BaseType } from "antd/lib/typography/Base";
import React from "react";
import * as Styles from "./styles";

interface TypographySmallComponentProps {
  type?: BaseType | "link";
}

type TypographySmallPropsType =
  React.PropsWithChildren<TypographySmallComponentProps>;

const TypographySmallComponent: React.FC<TypographySmallPropsType> = ({
  children,
  type,
}: TypographySmallPropsType) => {
  if (type && type !== "link") {
    return (
      <Typography.Text css={Styles.textStyle} type={type}>
        {children}
      </Typography.Text>
    );
  }

  return <span css={Styles.textStyle}>{children}</span>;
};

export const TypographySmall = React.memo(TypographySmallComponent);
